import { type Meta } from '@air/analytics';

const META: Meta = {
  description: 'User opened asset details panel',
  name: 'opened_asset_details',
  params: [
    {
      description: 'The clip/version ID of the asset',
      name: 'clip_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The asset ID',
      name: 'asset_id',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
